@use '../../styling/colors.scss' as *;

.Eggy {
  .purple {
    fill: $color-secondary-purple;
  }

  .green {
    fill: $color-eggy-hair;
  }

  .white {
    fill: $color-white;
  }

  .face {
    fill: $color-eggy-face;
  }

  .EggyTrademark {
    opacity: 0;
  }
}
